import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import HomeProducedTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import purchasedEnergyIcon from "../../../../../assets/design-revamp-company/category-icons/energy_produced_icon.svg";
const HomeProducedContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents">
      <SubHeaderBox
        subTitle={t("HOME_INPUT")}
        scope={"Scope 1"}
        subDescription={t("DESC_HOME")}
        isNormal={true}
        number={"2.2"}
        icon={purchasedEnergyIcon}
      />

      {showTable && <HomeProducedTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default HomeProducedContents;
